import { observer } from "mobx-react";
import React, { useContext } from "react";
import OrderSettingsPageStoreContext from "../context";

import { Alert, AlertTitle } from "@material-ui/lab";
import { Space } from "../../../../../common/components/libs";


const IIkoIntegrationMessage = () => {
    const store = useContext(OrderSettingsPageStoreContext);

    if(!store.hasIIkoIntegration) return null;
    return <>
        <Alert severity={'warning'}>
            <AlertTitle>Включена интеграция с IIko</AlertTitle>
            Заказы напрямую идут в IIko.
        </Alert>
        <Space size={8}/>
    </>

}


export default observer(IIkoIntegrationMessage)
